import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import {
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './FooterLinks.tokens';

export const StyledList = styled.ul`
    ${styledReset.list};
    display: grid;
    grid-auto-flow: column;
    align-content: center;
    justify-content: center;
    text-align: center;
`;

export const Item = styled.li`
    display: grid;
    grid-auto-flow: column;

    &::before {
        ${styledTypography.allianceBase};
        display: block;
        margin-left: ${tokens.gap}px;
        margin-right: ${tokens.gap}px;
        font-size: ${tokens.fontSize}px;
        font-weight: 500;
        color: rgb(255, 255, 255, 0.4);
    }

    &:nth-child(n + 2)::before {
        content: '•';
    }
`;

export const Link = styled(RouterLink)`
    ${styledReset.link};
    ${styledTypography.allianceBase};
    display: block;
    font-size: ${tokens.fontSize}px;
    font-weight: 500;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.3);
    /* Important required because of global reset rules. */
    text-decoration: underline 1px transparent !important;
    transition-property: color, text-decoration-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 1);
        text-decoration-color: rgb(255, 255, 255, 1) !important;
    }

    &:active {
        color: rgb(255, 255, 255, 0.8);
        text-decoration-color: rgb(255, 255, 255, 0.8) !important;
    }
`;
